// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"503":"sql-formatter","736":"vendor"}[chunkId] || chunkId) + "." + {"449":"6a14a744f28eab8bf3ca","503":"8b23c4aa60ee4a11f14e","736":"e286d843828e285a099b"}[chunkId] + ".js";
};